export default {"src":"/_next/static/image/components/ui/Icon/icons/eye.fbbe0d2980a8f4f0604e0b87cf4abc9f.svg","height":10,"width":16};